import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useDispatch } from "react-redux";
import "./App.css";
import { HomePage } from "./components/home/HomePage";
import { CreateVendor } from "./components/serviceprovider/CreateVendor";
import { SearchVendor } from "./components/serviceprovider/SearchVendor";
import { UpdateVendor } from "./components/serviceprovider/UpdateVendor";
import { ForbiddenPage } from "./components/core/ForbiddenPage";
import { Admin } from "./components/admin/Admin";
import { EmailVerify } from "./components/email/EmailVerify";
import { NotFound } from "./components/notFound/NotFound";
import { setUser } from "./redux/userSlice";
import { useEffect } from "react";
import {ErrorBoundary} from "./components/core";

function App() {
  const dispatch = useDispatch();
  let profile = JSON.parse(sessionStorage.getItem("profile"));
  useEffect(() => {
    if (profile) {
      dispatch(setUser(profile));
    }
  }, [profile, dispatch]);

  return (
    <ErrorBoundary>
      <BrowserRouter future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/create-serviceprovider" element={<CreateVendor />} />
          <Route path="/search-serviceprovider" element={<SearchVendor />} />
          <Route path="/update-serviceprovider" element={<UpdateVendor />} />
          <Route path="/forbidden" element={<ForbiddenPage />} />
          <Route path="/admin" element={<Admin />} />
          <Route
            path="/verify-email/:id/:type/:token"
            element={<EmailVerify />}
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
